import { stackReducer } from './stackReducer';
import { StackPageAction, State } from './types';

type Subscriber = (state: State) => void;

let _subscriberStack: { id: symbol; subscriber: Subscriber }[] = [];
let _state: State = { stack: [] };

export const dispatch = (action: StackPageAction) => {
  _state = stackReducer(_state, action);
  _subscriberStack.forEach(({ subscriber }) => subscriber(_state));
};

export const subscribe = (subscriber: Subscriber) => {
  const id = Symbol();
  _subscriberStack.push({ id, subscriber });
  return id;
};

export const unsubscribe = (id: symbol) => {
  _subscriberStack = _subscriberStack.filter(
    subscriber => subscriber.id !== id
  );
};

export const isStackPageNameVisible = (stackPageName: string): boolean => {
  return _state.stack.some(
    stackItem => stackItem.stackPageName === stackPageName
  );
};
